import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export function ImpersonationBanner() {
  const { impersonating, stopImpersonation } = useAuth();
  const { t } = useI18n();

  if (!impersonating) return null;

  return (
    <div
      data-testid="impersonation-banner"
      className="impersonation-banner sticky top-0 z-50 flex items-center justify-center gap-3 px-4 py-1.5 text-sm font-medium"
    >
      <span>
        {t("impersonation.banner")}:{" "}
        <span className="font-mono font-semibold">
          {impersonating.name} ({impersonating.global_id})
        </span>
      </span>
      <Button
        data-testid="stop-impersonation-btn"
        variant="ghost"
        size="sm"
        className="h-7 gap-1 bg-black/10 text-black hover:bg-black/20"
        onClick={stopImpersonation}
      >
        <X className="h-3 w-3" />
        {t("impersonation.stop")}
      </Button>
    </div>
  );
}
